var render, staticRenderFns
import script from "./CompanyFormatter.vue?vue&type=script&lang=js&"
export * from "./CompanyFormatter.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFormatter.vue?vue&type=style&index=0&id=32c5ae99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c5ae99",
  null
  
)

export default component.exports